import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { getAttributeValue } from '@/utils/productUtils';

import CheckboxV2 from '@/components/common/CheckboxV2';
import DesignationItem from '@/components/primeurAlert/DesignationItem';

import styles from './DesignationList.module.scss';
import { ATTRIBUTES } from '@/constants/product';

export const DesignationList = ({ designations, alertList = [], onAlertMe, isPrimeurAlert = false }) => {
  const { t } = useTranslation();

  const handleSelectedProduct = ({ partnumber, name, productName }) => {
    onAlertMe([partnumber], productName || name);
  };

  const partnumberList = (key) => {
    const list = [];
    designations[key].map((product) =>
      list.push(product.partnumber)
    );
    return list;
  };

  const isAllChecked = (key) => partnumberList(key).every((p) => alertList?.includes(p));

  const changeAll = (key, isAllChecked) => {
    onAlertMe(partnumberList(key), undefined, isAllChecked);
  };

  return (
    <div className={styles.container} data-test-id="designation-list" data-rbf="designation-list">
      {Object.keys(designations).map((key) => {
        return designations[key].length > 0 && (
          <div className={styles.appelation} key={key}>
            <div className={styles.title}>{key}</div>
            {!isPrimeurAlert && (
              <CheckboxV2
                label={`${t('alert.subscribeToAllAlerts')} : ${key}`}
                onChange={() => changeAll(key, isAllChecked(key))}
                checked={isAllChecked(key)}
                className={styles.checkbox}
              />
            )}
            {designations[key].map((product) => {
              const { productName, partnumber } = product;
              return (
                <DesignationItem
                  title={productName}
                  color={getAttributeValue(product, ATTRIBUTES.COLOR)}
                  isChecked={alertList?.includes(partnumber)}
                  onClick={() => handleSelectedProduct(product)}
                  key={partnumber}
                />
              );
            }
            )}
          </div>
        );
      })}
    </div>
  );
};

DesignationList.propTypes = {
  designations: PropTypes.object.isRequired,
  alertList: PropTypes.array,
  onAlertMe: PropTypes.func.isRequired,
  isPrimeurAlert: PropTypes.bool
};

export default DesignationList;
